export const folder="/folder/";
export const download = "/api/FileManager/Download/"